type UnknownRecord = Record<string, unknown>;

const isRecord = (value: unknown): value is UnknownRecord =>
  typeof value === "object" && value !== null && !Array.isArray(value);

const parseJsonString = (value: string): unknown => {
  const normalized = value
    .trim()
    .replace(/^```(?:json)?\s*/i, "")
    .replace(/\s*```$/, "");

  try {
    return JSON.parse(normalized);
  } catch (error) {
    return value;
  }
};

export const hasNoAiSummaryData = (payload: unknown): boolean => {
  let current =
    typeof payload === "string" ? parseJsonString(payload) : payload;

  for (let depth = 0; depth < 5; depth += 1) {
    if (!isRecord(current)) {
      return false;
    }

    if (
      current.print_summary === 0 ||
      (typeof current.print_summary === "string" &&
        current.print_summary.trim() === "0")
    ) {
      return true;
    }

    const nested = current.data ?? current.response ?? current.result;
    if (nested === undefined || nested === current) {
      return false;
    }

    current = typeof nested === "string" ? parseJsonString(nested) : nested;
  }

  return false;
};
